//angular
import { Component, OnInit, OnDestroy } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { MatIconRegistry } from '@angular/material/icon';
//app
import { AppAnimations } from '../../../../../_shared/animations';
import { FormGroup, FormControl } from '@angular/forms';
import { User } from '../../../../../_shared/models/user.model';
import { SharedGlobalService } from 'src/app/_core/services/api/shared-global.service';
import { Unsubscriber } from 'src/app/_shared/unsubscriber/unsubscriber';

@Component({
  selector: 'account-settings',
  templateUrl: './account-settings.component.html',
  animations: [AppAnimations]
})

export class DialogAccountSettingsComponent implements OnInit, OnDestroy {
  formPassword: FormGroup;
  formProfile: FormGroup;
  formIsLoaded: boolean = false;
  formSubmitted: boolean;
  user: User = new User;
  private subs = new Unsubscriber();

  constructor(
    private _iconRegistry: MatIconRegistry,
    private _sanitizer: DomSanitizer,
    private sharedGlobalService: SharedGlobalService,
  ) {
    this._iconRegistry.addSvgIcon('ico-password', this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/ico-lock-01.svg'));
    this._iconRegistry.addSvgIcon('ico-profile', this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/ico-customers-01.svg'));
    this.formPassword = new FormGroup({
      password: new FormControl(''),
      confirmPassword: new FormControl('')
    })
    this.formProfile = new FormGroup({
      firstname: new FormControl(null),
      lastname: new FormControl(null),
      username: new FormControl({ value: '', disabled: true }),
      phoneNum: new FormControl(null)
    })
  }

  getUserProfile() {
    this.formIsLoaded = false;
    setTimeout(() => {
      this.subs.addSub = this.sharedGlobalService.getCurrentUserProfile().subscribe(
        success => {
          if (success.code == 200) {
            this.user = new User().deserialize(success.data);
            this.formProfile.controls.firstname.setValue(this.user.firstName);
            this.formProfile.controls.lastname.setValue(this.user.lastName);
            this.formProfile.controls.username.setValue(this.user.username);
            this.formProfile.controls.phoneNum.setValue(this.user.phoneNum);
          }
          this.formIsLoaded = true;
          console.log('account-settings.component.ts - getUserProfile() [SUCCESS]');
        },
        error => {
          this.formIsLoaded = true;
          console.log('account-settings.component.ts - getUserProfile() [ERROR]');
        }
      );
    }, 300);

  }

  ngOnInit(){
    this.getUserProfile();
  }

  updateProfile(){
    if (this.formProfile.valid){
      this.formSubmitted = !this.formSubmitted;
      this.subs.addSub = this.sharedGlobalService.updateUserProfile(this.formProfile).subscribe(
        res => {
          if (res.code == 200) {
            this.formSubmitted = !this.formSubmitted;
            console.log('account-settings.component.ts - updateProfile() [SUCCESS]');
          } else {
            this.formSubmitted = !this.formSubmitted;
            console.log('account-settings.component.ts - updateProfile() [ERROR]');
          }
        },
        err => {
          this.formSubmitted = !this.formSubmitted;
          console.log('account-settings.component.ts - updateProfile() [ERROR] - Can not connect with the API');
        }
      );
    }
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }
}
